var React = require('react');

function Station (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#000000","strokeWidth":"9","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"M66.45,69.233l97.901,44.891H12.485v30.564h152.821l-74.5,35.817h-78.32v30.086h78.32l93.124,44.892h69.726l-97.9-44.892h152.343\n\t  v-30.086H155.754l74.499-36.295h77.844v-30.564h-78.321l-93.124-44.891H66.45"}));
}

Station.defaultProps = {"x":"0px","y":"0px","width":"316px","height":"316px","viewBox":"0 0 316 316","enableBackground":"new 0 0 316 316","xmlSpace":"preserve"};

module.exports = Station;

Station.default = Station;
